//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'content-example',
  props: {
    isFluid: {
      type: Boolean,
      default: false
    },
    noFlex: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'xs12 m6 offset-m3'
    }
  }
};